import { useState, useMemo } from 'react';
import DateFormatter from 'formatters/DateFormatter';
import { getLabelFromValue } from 'pages/backendSearch/backendSearchConstants';

const formatRow = (row, key) => {
	let text = row[key] || '-';
	if (key?.toLowerCase()?.includes('date')) {
		text = <DateFormatter text={text} />;
	}
	return text;
}

const buildTable = (data) => {
	return (
		<table className="table table-striped data-table">
			<thead>
				<tr>
					{Object.keys(data[0]).map((key) => (
						<th key={key} className="">{key}</th>
					))}
				</tr>
			</thead>
			<tbody>
				{data.map((row, i) => (
					<tr key={i}>
						{Object.keys(row).map((key) => (
							<td key={key} className="">{formatRow(row, key)}</td>
						))}
					</tr>
				))}
			</tbody>
		</table>
	);
}

const BackendSearchTable = ({ data, dataSet, searchString, resultPage }) => {
	const [tableSearchTerm, setTableSearchTerm] = useState('');

	// Filter data based on table search term
	const filteredData = useMemo(() => {
		if (!data || !data.length || !tableSearchTerm) return data;

		const lowerSearch = tableSearchTerm.toLowerCase();
		return data.filter(row => {
			// Search across all cell values in the row
			return Object.values(row).some(value => {
				const stringValue = String(value || '').toLowerCase();
				return stringValue.includes(lowerSearch);
			});
		});
	}, [data, tableSearchTerm]);

	let tableElement = null;
	if (!data || !data.length) {
		if (searchString && dataSet) {
			tableElement = (
				<div className="backend-search-nothing-found mt-5 mb-4">
					{`No results found for "${searchString}" in ${getLabelFromValue(dataSet)}, page ${resultPage}`}
				</div>
			);
		}
	} else if (data?.length) {
		const displayData = filteredData || data;
		const hasFilteredResults = filteredData && filteredData.length !== data.length;

		tableElement = (
			<div className="mt-2">
				<div className="backend-search-table-header">
					<div className="small-text">{`Results for "${searchString}" in ${getLabelFromValue(dataSet)}, page ${resultPage}`}</div>
					<div className="backend-search-table-search-wrapper">
						<div className="backend-search-table-search-input-wrapper">
							<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className="backend-search-table-search-icon">
								<path d="M7.5 13.5C10.8137 13.5 13.5 10.8137 13.5 7.5C13.5 4.18629 10.8137 1.5 7.5 1.5C4.18629 1.5 1.5 4.18629 1.5 7.5C1.5 10.8137 4.18629 13.5 7.5 13.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
								<path d="M14.5 14.5L11.5 11.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
							</svg>
							<input
								type="text"
								className="form-control backend-search-table-search-input"
								placeholder="Search in results..."
								value={tableSearchTerm}
								onChange={(e) => setTableSearchTerm(e.target.value)}
							/>
							{tableSearchTerm && (
								<button
									className="backend-search-table-search-clear"
									onClick={() => setTableSearchTerm('')}
									type="button"
								>
									<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
									</svg>
								</button>
							)}
						</div>
						{hasFilteredResults && (
							<div className="backend-search-table-filter-info">
								Showing {displayData.length} of {data.length} results
							</div>
						)}
					</div>
				</div>
				{displayData.length > 0 ? (
					<div className="backend-search-results-table-wrapper">
						{buildTable(displayData)}
					</div>
				) : (
					<div className="backend-search-nothing-found mt-3 mb-4">
						No results match "{tableSearchTerm}"
					</div>
				)}
			</div>
		);
	}
	return tableElement;
}

export default BackendSearchTable;
